import axios from 'axios';   
import EndPoints from '../constants/endPoints'; 
import { SuburbResource } from '../models/resource/suburbResource';
import { SuburbRequest } from '../models/request/suburbRequest';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ALMOWAZI_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use((config) => {
  const authToken = localStorage.getItem('token');
  if (authToken) {
    const tokenData = JSON.parse(atob(authToken.split('.')[1]));
    const tokenExp = tokenData.exp * 1000; 
    const currentTime = new Date().getTime(); 

    if (tokenExp < currentTime) { 
      localStorage.removeItem('token'); 
      localStorage.setItem('expired','true'); 
      window.location.href = '/Signin';
    } else {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    return Promise.reject(error);
  }
);
 
const deleteSuburb = async (id: number): Promise<any> => {
  try {
    const response = await axiosInstance.delete(EndPoints.Suburb.Delete, { params: { id } });
    return response;
  } catch (error) {
    console.error('Failed to delete Suburb:', error);
    throw new Error('Failed to delete Suburb');
  }
};

const getSuburbs = async (countryId: number): Promise<any> => {
  try { 
      const response = await axiosInstance.get(EndPoints.Suburb.GetAll, {
        params: { countryId }
      });  
      return response;
  } catch (error) { 
      throw new Error('Failed to get Suburb');
  }
}; 

const getSuburbsList = async (data: SuburbRequest): Promise<any> => {
  try {
    const response = await axiosInstance.get(EndPoints.Suburb.GetPageList, {
      params: data,
    });
    return response;
  } catch (error) {
    throw new Error("Failed to get Suburbs list");
  }
};
const getSuburbById =  async (id: number): Promise<any> => {
  try {
    const response = await axiosInstance.get(EndPoints.Suburb.GetById, {
      params: { id }
    });  
    return response;
  } catch (error) {
    throw new Error('Failed to get Suburb');
  }
};

const saveSuburb = async (data: SuburbResource): Promise<any> => {
  try { 
    const response = await axiosInstance.post(EndPoints.Suburb.Save, data); 
    return response;
  } catch (error) { 
    throw new Error('Failed to save Suburb');
  }
};

export const suburbService = {
    getSuburbs, 
    saveSuburb, 
    getSuburbById, 
    getSuburbsList, 
    deleteSuburb
};
